import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=668ebb6b&scoped=true"
import script from "./SectionCard.vue?vue&type=script&lang=js"
export * from "./SectionCard.vue?vue&type=script&lang=js"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=668ebb6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ebb6b",
  null
  
)

export default component.exports